{
  "dismiss": "Avvisa"
}
